export const fieldArguments = `
$includeProject: Boolean! = false
$includeRoleCurrentRate: Boolean! = false
$includeUserPermittedActions: Boolean! = true
$includeUserRoles: Boolean! = true
`;
